import { render } from "./ContactForm.vue?vue&type=template&id=1dc24c79"
import script from "./ContactForm.vue?vue&type=script&lang=js"
export * from "./ContactForm.vue?vue&type=script&lang=js"

import "./ContactForm.vue?vue&type=style&index=0&id=1dc24c79&lang=css"
script.render = render

export default script